import { cn } from "../../utils/utils";

export const MyRadio = ({
  label,
  onChange,
  checked,
  className = "",
  inputClassName = "",
  labelClassName = "",
  disabled = false,
  ...props
}) => {
  return (
    <div className={cn("inline-flex items-center", className)}>
      <label className="relative flex cursor-pointer items-center rounded-full p-2">
        <input
          disabled={disabled}
          type="radio"
          onChange={onChange}
          checked={checked || ""}
          className={cn(
            `before:content[''] peer h-5 w-5 ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"} appearance-none rounded-full border border-slate-500 checked:border-primary transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-slate-400 before:opacity-0 before:transition-opacity hover:before:opacity-10 bg-white`,
            inputClassName,
          )}
          {...props}
        />
        <span className="absolute bg-primary w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
      </label>
      <label
        className={cn("text-slate-600 cursor-pointer text-sm", labelClassName)}
      >
        {label}
      </label>
    </div>
  );
};
